export const SETTINGS_TAB = {
  design: 'design',
  layout: 'layout',
  settings: 'settings',
} as const;

export type SettingsType = (typeof SETTINGS_TAB)[keyof typeof SETTINGS_TAB];

export const GALLERY_LAYOUT_DROPDOWN = 'GALLERY.layout';

export const GALLERY_MEDIA_SETTINGS_MODAL = 'GALLERY.mediaSettings';
export const GALLERY_LAYOUT_SETTINGS_MODAL = 'GALLERY.layoutSettings';
export const GALLERY_SETTINGS_MODAL_ID = 'GALLERY.settings';

export const fileInputAccept = 'image/*,video/*';
